import Toggle from '@/components/Toggle';
import clsx from '@/lib/clsx';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors';
import selectors from '@/redux/selectors/selectors';
import appActions from '@/screens/apps/redux/actions/appActions';
import appScreenSelectors from '@/screens/apps/redux/selectors/appScreenSelectors';
import { useSelector } from 'react-redux';

const WizardToggleButton = () => {
  const section = useArgSelector(selectors.param, 'section');
  const actionId = useSelector((state) => appScreenSelectors.activeAppAction(state)?.id);
  const wizardMode = useSelector((state) => appScreenSelectors.activeAppAction(state)?.meta?.wizardMode === true);

  const handleWizardToggle = () => {
    appActions.set(`actions[id:${actionId}].meta.wizardMode`, wizardMode !== true);
  };

  if (section !== 'actions') {
    return null;
  }

  return (
    <div className={clsx('comp-wizard-toggle-btn', wizardMode && 'active')} onClick={handleWizardToggle}>
      <Toggle size={'xs'} active={wizardMode} />
      <p>Wizard Mode</p>
    </div>
  );
};

export default WizardToggleButton;
